module.exports = __webpack_public_path__ + "static/img/icon-mail.aefeb85.png";